import { makeStyles } from "@material-ui/core";


const opacity = require("hex-color-opacity");


export default makeStyles((theme) => ({
    wrapper: {
        height: "100%",
        margin: "auto",
        aspectRatio: "16/9",
        position: "relative",
    },
    cameraRole: {
        height: "fit-content",
        "&:disabled": {
            color: theme.palette.common.white,
            backgroundColor: theme.palette.common.black,
        },
    },
    cameraRoleIcon: {
        color: theme.palette.secondary.main,
    },
    cameraRoleText: {},
    controlsWrapper: {
        height: "100%",
        width: "100%",
        position: "absolute",
        top: 0,
        left: 0,
        padding: "1em",
    },
    controls: {
        height: "100%",
        position: "relative",
    },
    controlText: {
        color: theme.palette.common.white,
        marginLeft: "0.5em",
        fontWeight: "bolder",
        textShadow: `-4px 4px 8px ${theme.palette.common.black}`,
    },
    controlButton: {
        color: theme.palette.common.white,
        "&:hover": {
            backgroundColor: opacity(theme.palette.common.black, 0.5),
        },
    },
    playAndTime: {
        display: "flex",
        alignItems: "center",
    },
    controlsTop: {
        top: 0,
        position: "absolute",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        width: "100%",
        height: "2.5em",
    },
    controlsBottom: {
        width: "100%",
        position: "absolute",
        display: "flex",
        flexDirection: "column",
        bottom: 0,
    },
    slider: {
        color: theme.palette.common.white,
    },
}));
